import { io } from "socket.io-client";

const SOCKET_URL = "https://api-v2-prod.qapin.com";
let socket = null;

const initializeSocket = (store) => {
  const connectSocket = () => {
    const token = store.state.currentUserData?.token; // Get latest token
    const event = store.state.byPassEvent; // Get latest event

    // 🔴 Ensure we close the previous socket before reconnecting
    if (socket) {
      socket.disconnect();
      socket = null;
    }

    console.log("🔄 Initializing socket...");
    console.log("✅ Event to bypass:", event);
    console.log("🔑 Token:", token);

    // Prepare authentication & query parameters
    const socketOptions = {
      transports: ["websocket"],
      auth: { 
        timeZone: store.state.userTimeZone,
        token: token || null // Pass token if available
      },
      query: event ? { event } : {} // Only send event if exists
    };

    // 🔄 Create new socket connection
    socket = io(SOCKET_URL, socketOptions);

    socket.on("connect", () => {
      console.log("✅ Socket connected:", socket.id);
      store.commit('SET_SOCKET', socket); // Update the socket connection state
      store.commit('setSocketConnected', true); // Update the socket connection state

    });

    socket.on("disconnect", () => {
      console.log("❌ Socket disconnected");
      store.commit('SET_SOCKET', null); // Update the socket connection state
      store.commit('setSocketConnected', false); // Update the socket connection state

    });

    socket.on("connect_error", (err) => {
      console.error("🚨 Socket connection error:", err.message);
    });

    // 🔄 Watch for `byPassEvent` updates and reconnect if needed
    store.watch(
      (state) => state.byPassEvent,
      (newEvent, oldEvent) => {
        if (newEvent !== oldEvent) {
          console.log(`🔄 Event changed from ${oldEvent} to ${newEvent}, reconnecting socket...`);
          connectSocket();
        }
      }
    );
  };

  // 🔄 Ensure state is updated before connecting
  if (store.state.byPassEvent || store.state.currentUserData?.token) {
    connectSocket();
  } else {
    store.watch(
      (state) => state.byPassEvent,
      (event) => {
        if (event || store.state.currentUserData?.token) {
          console.log("🔄 State updated, initializing socket...");
          connectSocket();
        }
      }
    );
  }
};

export default {
  install: (Vue, { store }) => {
    initializeSocket(store);
    Vue.prototype.$socket = socket; // Make socket available globally
  },
};

export { socket };